import type { CustomerCommentsStore } from './interfaces'

import { isFullArray } from '@helpers/array'

export const getters = {
  isLoading: (state: CustomerCommentsStore): CustomerCommentsStore['loading'] => state.loading,
  isLoadingMore: (state: CustomerCommentsStore): CustomerCommentsStore['loadingMore'] => state.loadingMore,
  getComments: (state: CustomerCommentsStore): CustomerCommentsStore['comments'] => state.comments,
  hasComments: (state: CustomerCommentsStore): boolean => isFullArray(state.comments),
  getNextCursor: (state: CustomerCommentsStore): CustomerCommentsStore['nextCursor'] => state.nextCursor,
  hasMore: (state: CustomerCommentsStore): boolean => !!state.nextCursor,
  getFilterDisciplines: (state: CustomerCommentsStore): CustomerCommentsStore['filterDisciplines'] => state.filterDisciplines,
  getPerPage: (state: CustomerCommentsStore): CustomerCommentsStore['perPage'] => state.perPage,
}
